import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ScannerPopUpComponent } from './Components/PopUps/ScannerPopUpComponent';
import { AuthCallbackComponent } from './Components/account/auth-callback/auth-callback.component';
import { SilentCallbackComponent } from './Components/account/auth-callback/silent-callback.component';
import { SupportCallbackComponent } from './Components/account/auth-callback/support-callback.component';
import { actConfirmComponent } from './Components/account/confirm/actConfirm.component';
import { emailConfirmComponent } from './Components/account/confirm/emailConfirm.component';
import { SettingsShellComponent } from './Components/shell/SettingsShellComponent';
import { StorageShellComponent } from './Components/shell/StorageShellComponent';
import { PersonRoleEnum } from './Models/OtherClasses';
import { RoleAuthGuard } from './RoutingAuth/RoleAuthGuard';
import { AuthGuard } from './RoutingAuth/auth.guard';
import { RouterComponent } from './Services/RouterComponent';
import { ReportsShellComponent } from './Components/shell/ReportsShellComponent';
import { ViewerComponent } from './Components/3rdParty/ViewerComponent';


const routes: Routes = [
	{
		path: 'ang/Home', loadChildren: () => import(`./Components/home/home.module`).then(
			m => m.HomeModule
		)
	},
	{ path: 'silent-callback', component: SilentCallbackComponent, },
	{ path: 'support-callback', component: SupportCallbackComponent, },
	{ path: 'auth-callback', component: AuthCallbackComponent },
	{ path: 'emailconfirm/:id', component: emailConfirmComponent },
	{ path: 'emailconfirm', component: emailConfirmComponent },
	{ path: 'actconfirm', component: actConfirmComponent },
	{ path: 'viewer/:id', component: ViewerComponent },
	{
		path: 'ang/Scan',
		canActivate: [RoleAuthGuard],
		canActivateChild: [RoleAuthGuard],
		data: {
			allowedRoles: [PersonRoleEnum.SYSTEMROLEEMPLOYEE]
		},
		component: ScannerPopUpComponent
	},
	{
		path: 'ang/Company',
		canActivate: [AuthGuard, RoleAuthGuard],
		canActivateChild: [AuthGuard, RoleAuthGuard],
		data: {
			allowedRoles: [PersonRoleEnum.ADMIN]
		},
		loadChildren: () => import(`./Components/Company/Company.Module`).then(
			m => m.CompanyModule
		)
	},
	{
		path: 'ang/Reports',
		component: ReportsShellComponent,
		canActivate: [AuthGuard, RoleAuthGuard],
		canActivateChild: [AuthGuard, RoleAuthGuard],
		data: {
			allowedRoles: [PersonRoleEnum.ADMIN, PersonRoleEnum.TREASURY]
		},
		children: [
			{
				path: '',
				canActivate: [AuthGuard],
				canActivateChild: [AuthGuard],
				data: {
					allowedRoles: [PersonRoleEnum.ADMIN, PersonRoleEnum.TREASURY]
				},
				loadChildren: () => import(`./Components/Reports/Reports.Module`).then(
					m => m.ReportsModule
				),
			},
		]
	},
	{
		path: 'ang/Person',
		canActivate: [AuthGuard],
		canActivateChild: [AuthGuard],
		loadChildren: () => import(`./Components/Person/Person.Module`).then(
			m => m.PersonModule
		)
	},
	{
		path: 'ang/Storage',
		component: StorageShellComponent,
		canActivate: [AuthGuard, RoleAuthGuard],
		canActivateChild: [AuthGuard, RoleAuthGuard],
		data: {
			allowedRoles: [PersonRoleEnum.SYSTEMROLEEMPLOYEE]
		},
		children: [
			{
				path: '',
				redirectTo: 'Location',
				pathMatch: 'full' 
			},
			{
				path: 'Location',
				canActivate: [AuthGuard],
				canActivateChild: [AuthGuard],
				data: {
					allowedRoles: [PersonRoleEnum.SYSTEMROLEEMPLOYEE]
				},
				loadChildren: () => import(`./Components/StorageLocation/StorageLocation.Module`).then(
					m => m.StorageLocationModule
				)
			},
			{
				path: 'Items',
				canActivate: [AuthGuard],
				canActivateChild: [AuthGuard],
				data: {
					allowedRoles: [PersonRoleEnum.SYSTEMROLEEMPLOYEE]
				},
				loadChildren: () => import(`./Components/PropertyItem/PropertyItem.Module`).then(
					m => m.PropertyItemModule
				)
			},
			{
				path: 'BOL',
				canActivate: [AuthGuard],
				canActivateChild: [AuthGuard],
				data: {
					allowedRoles: [PersonRoleEnum.SYSTEMROLEEMPLOYEE]
				},
				loadChildren: () => import(`./Components/ShipmentBOL/ShipmentBOL.Module`).then(
					m => m.ShipmentBOLModule
				)
			},
			{
				path: 'WillCall',
				canActivate: [AuthGuard],
				canActivateChild: [AuthGuard],
				data: {
					allowedRoles: [PersonRoleEnum.SYSTEMROLEEMPLOYEE]
				},
				loadChildren: () => import(`./Components/StorageLocation/WillCall.Module`).then(
					m => m.WillCallModule
				)
			},
		]
	},
	{
		path: 'ang/CustomerTemplate',
		loadChildren: () => import(`./Components/CommunicationTemplate/CommunicationTemplate.Module`).then(
			m => m.CommunicationTemplateModule
		),
		canActivate: [RoleAuthGuard],
		canActivateChild: [RoleAuthGuard],
		data: {
			allowedRoles: [PersonRoleEnum.ADMIN]
		},
	},
	{ 
		path: 'ang/Settings',
		component: SettingsShellComponent,
		canActivate: [AuthGuard],
		canActivateChild: [AuthGuard],
		children: [
			{
				path: '',
				redirectTo: 'Company',
				pathMatch: 'full' 
			},
			{
				path: 'Users',
				canActivate: [AuthGuard],
				canActivateChild: [AuthGuard],
				loadChildren: () => import(`./Components/Person/Person.Module`).then(
					m => m.PersonModule
				)
			},
			{
				path: 'Instructions',
				canActivate: [AuthGuard],
				canActivateChild: [AuthGuard],
				loadChildren: () => import(`./Components/AppInstructions/AppInstructions.Module`).then(
					m => m.AppInstructionsModule
				),
				data: {
					allowedRoles: [PersonRoleEnum.SUPERADMIN]
				},
			},
			{
				path: 'Company',
				canActivate: [AuthGuard],
				canActivateChild: [AuthGuard],
				loadChildren: () => import(`./Components/Company/Company.Module`).then(
					m => m.CompanyModule
				),
				data: {
					allowedRoles: [PersonRoleEnum.ADMIN]
				},
			},
			{
				path: 'CommVia',
				canActivate: [AuthGuard],
				canActivateChild: [AuthGuard],
				loadChildren: () => import(`./Components/CommVia/CommVia.Module`).then(
					m => m.CommViaModule
				),
				data: {
					allowedRoles: [PersonRoleEnum.ADMIN]
				},
			},
			{
				path: 'TypeCountry',
				canActivate: [RoleAuthGuard],
				canActivateChild: [RoleAuthGuard],
				data: {
					allowedRoles: [PersonRoleEnum.SUPERADMIN]
				},
				loadChildren: () => import(`./Components/TypeCountry/TypeCountry.Module`).then(
					m => m.TypeCountryModule
				)
			},
			{
				path: 'TypeCustomerAccount',
				canActivate: [RoleAuthGuard],
				canActivateChild: [RoleAuthGuard],
				data: {
					allowedRoles: [PersonRoleEnum.ADMIN]
				},
				loadChildren: () => import(`./Components/TypeCustomerAccount/TypeCustomerAccount.Module`).then(
					m => m.TypeCustomerAccountModule
				)
			},
			{
				path: 'TypeStorageFee',
				canActivate: [RoleAuthGuard],
				canActivateChild: [RoleAuthGuard],
				data: {
					allowedRoles: [PersonRoleEnum.ADMIN]
				},
				loadChildren: () => import(`./Components/TypeStorageFee/TypeStorageFee.Module`).then(
					m => m.TypeStorageFeeModule
				)
			},
			{
				path: 'TypeCancellationReason',
				canActivate: [RoleAuthGuard],
				canActivateChild: [RoleAuthGuard],
				data: {
					allowedRoles: [PersonRoleEnum.ADMIN]
				},
				loadChildren: () => import(`./Components/TypeCancellationReason/TypeCancellationReason.Module`).then(
					m => m.TypeCancellationReasonModule
				)
			},
			{
				path: 'TypeOrderTag',
				canActivate: [RoleAuthGuard],
				canActivateChild: [RoleAuthGuard],
				data: {
					allowedRoles: [PersonRoleEnum.ADMIN]
				},
				loadChildren: () => import(`./Components/TypeOrderTag/TypeOrderTag.Module`).then(
					m => m.TypeOrderTagModule
				)
			},
			{
				path: 'TypePaymentSource',
				canActivate: [RoleAuthGuard],
				canActivateChild: [RoleAuthGuard],
				data: {
					allowedRoles: [PersonRoleEnum.SUPERADMIN]
				},
				loadChildren: () => import(`./Components/TypePaymentSource/TypePaymentSource.Module`).then(
					m => m.TypePaymentSourceModule
				)
			},
			{
				canActivate: [RoleAuthGuard],
				canActivateChild: [RoleAuthGuard],
				data: {
					allowedRoles: [PersonRoleEnum.ADMIN]
				},
				path: 'ReferralSource', loadChildren: () => import(`./Components/ReferralSource/ReferralSource.Module`).then(
					m => m.ReferralSourceModule
				)
			},
			{
				canActivate: [RoleAuthGuard],
				canActivateChild: [RoleAuthGuard],
				data: {
					allowedRoles: [PersonRoleEnum.ADMIN]
				},
				path: 'CommTemplate', loadChildren: () => import(`./Components/CommunicationTemplate/CommunicationTemplate.Module`).then(
					m => m.CommunicationTemplateModule
				)
			},
			{
				canActivate: [RoleAuthGuard],
				canActivateChild: [RoleAuthGuard],
				data: {
					allowedRoles: [PersonRoleEnum.ADMIN]
				},
				path: 'TypePropertyItem', loadChildren: () => import(`./Components/TypePropertyItem/TypePropertyItem.Module`).then(
					m => m.TypePropertyItemModule
				)
			},
			{
				canActivate: [RoleAuthGuard],
				canActivateChild: [RoleAuthGuard],
				data: {
					allowedRoles: [PersonRoleEnum.ADMIN]
				},
				path: 'TypeTruck', loadChildren: () => import(`./Components/TypeTruck/TypeTruck.Module`).then(
					m => m.TypeTruckModule
				)
			},
			{
				canActivate: [RoleAuthGuard],
				canActivateChild: [RoleAuthGuard],
				data: {
					allowedRoles: [PersonRoleEnum.ADMIN]
				},
				path: 'SurveyQuestion',
				loadChildren: () => import(`./Components/SatisfactionSurveyQuestion/SatisfactionSurveyQuestion.Module`).then(
					m => m.SatisfactionSurveyQuestionModule
				)
			},
			{
				canActivate: [RoleAuthGuard],
				canActivateChild: [RoleAuthGuard],
				data: {
					allowedRoles: [PersonRoleEnum.ADMIN]
				},
				path: 'PromoCode',
				loadChildren: () => import(`./Components/CompanyPromoCode/CompanyPromoCode.Module`).then(
					m => m.CompanyPromoCodeModule
				)
			},
			{
				canActivate: [RoleAuthGuard],
				canActivateChild: [RoleAuthGuard],
				data: {
					allowedRoles: [PersonRoleEnum.ADMIN]
				},
				path: 'DeliveryZoneGroup',
				loadChildren: () => import(`./Components/DeliveryZoneGroup/DeliveryZoneGroup.Module`).then(
					m => m.DeliveryZoneGroupModule
				)
			},
			{
				canActivate: [RoleAuthGuard],
				canActivateChild: [RoleAuthGuard],
				data: {
					allowedRoles: [PersonRoleEnum.ADMIN]
				},
				path: 'Truck',
				loadChildren: () => import(`./Components/Truck/Truck.Module`).then(
					m => m.TruckModule
				)
			},
			{
				canActivate: [RoleAuthGuard],
				canActivateChild: [RoleAuthGuard],
				data: {
					allowedRoles: [PersonRoleEnum.ADMIN]
				},
				path: 'Checklist',
				loadChildren: () => import(`./Components/Checklist/Checklist.Module`).then(
					m => m.ChecklistModule
				)
			},
			{
				canActivate: [RoleAuthGuard],
				canActivateChild: [RoleAuthGuard],
				data: {
					allowedRoles: [PersonRoleEnum.ADMIN]
				},
				path: 'Agreement',
				loadChildren: () => import(`./Components/AgreementMaster/AgreementMaster.Module`).then(
					m => m.AgreementMasterModule
				)
			},
		]
	},
	{
		path: 'ang/Map',
		canActivate: [AuthGuard],
		canActivateChild: [AuthGuard],
		data: {
			allowedRoles: [PersonRoleEnum.SYSTEMROLEEMPLOYEE]
		},
		loadChildren: () => import(`./Components/Map/DispatchMap.Module`).then(
			m => m.DispatchMapModule
		)
	},
	{
		path: 'ang/Chat',
		canActivate: [AuthGuard],
		canActivateChild: [AuthGuard],
		data: {
			allowedRoles: [PersonRoleEnum.SYSTEMROLEEMPLOYEE]
		},
		loadChildren: () => import(`./Components/ChatMessage/ChatMessage.Module`).then(
			m => m.ChatMessageModule
		)
	},
	{
		path: 'ang/Upload',
		canActivate: [AuthGuard],
		canActivateChild: [AuthGuard],
		data: {
			allowedRoles: [PersonRoleEnum.SYSTEMROLEEMPLOYEE]
		},
		loadChildren: () => import(`./Components/UploadedFile/UploadedFile.Module`).then(
			m => m.UploadedFileModule
		)
	},
	{
		path: 'ang/CustomerInvoice',
		canActivate: [AuthGuard],
		canActivateChild: [AuthGuard],
		data: {
			allowedRoles: [PersonRoleEnum.SYSTEMROLEEMPLOYEE]
		},
		loadChildren: () => import(`./Components/CustomerInvoice/CustomerInvoice.Module`).then(
			m => m.CustomerInvoiceModule
		)
	},
	{
		path: 'ang/Payment',
		canActivate: [AuthGuard],
		canActivateChild: [AuthGuard],
		data: {
			allowedRoles: [PersonRoleEnum.SYSTEMROLEEMPLOYEE]
		},
		loadChildren: () => import(`./Components/Payment/Payment.Module`).then(
			m => m.PaymentModule
		)
	},
	{
		path: 'ang/PickupDelivery',
		canActivate: [AuthGuard],
		canActivateChild: [AuthGuard],
		data: {
			allowedRoles: [PersonRoleEnum.SYSTEMROLEEMPLOYEE]
		},
		loadChildren: () => import(`./Components/PickupDelivery/PickupDelivery.Module`).then(
			m => m.PickupDeliveryModule
		)
	},
	{
		path: 'ang/Driver',
		canActivate: [AuthGuard, RoleAuthGuard],
		canActivateChild: [AuthGuard, RoleAuthGuard],
		data: {
			allowedRoles: [PersonRoleEnum.DRIVER]
		},
		loadChildren: () => import(`./Components/PickupDeliveryDriver/PickupDeliveryDriver.Module`).then(
			m => m.PickupDeliveryDriverModule
		)
	},
	{
		path: 'ang/CustomerAccount',
		canActivate: [AuthGuard],
		canActivateChild: [AuthGuard],
		loadChildren: () => import(`./Components/CustomerAccount/CustomerAccount.Module`).then(
			m => m.CustomerAccountModule
		)
	},
	
	


	{
		path: 'Survey',
		loadChildren: () => import(`./Components/SatisfactionSurveyResponse/SatisfactionSurveyResponse.Module`).then(
			m => m.SatisfactionSurveyResponseModule
		)
	},
	{
		path: 'Reserve',
		loadChildren: () => import(`./Components/Reservations/Reservations.Module`).then(
			m => m.ReservationsModule
		)
	},
	{
		path: 'Public',
		loadChildren: () => import(`./Components/PickupDeliveryPublic/PickupDeliveryPublic.Module`).then(
			m => m.PickupDeliveryPublicModule
		)
	},
	// Fallback when no prior route is matched
	{ path: '**', redirectTo: '/ang/Home', pathMatch: 'full' }
];

@NgModule({
	imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled'})],
	exports: [RouterModule],
	declarations: [
		RouterComponent
	],
	providers: [
		RoleAuthGuard,
		AuthGuard
	]
})
export class AppRoutingModule { }
